'use client';

import type { MouseEventHandler, ReactNode } from 'react';
import styles from './active-filters-section.module.scss';
import FilterButton from '../filter-button';
const ActiveFiltersSection = ({
	handleFilterButtonClick,
	children,
	showButtonmobileOnly,
}: IProps) => {
	return (
		<div className={styles.wrapper}>
			<FilterButton
				handleClick={handleFilterButtonClick}
				mobileOnly={showButtonmobileOnly}
			/>
			{children}
		</div>
	);
};

export interface IProps {
	showButtonmobileOnly?: boolean;
	handleFilterButtonClick: MouseEventHandler;
	children: ReactNode;
}
export default ActiveFiltersSection;
